import actionTypes from 'constants/actionTypes'
import { clearModes } from './graph'

type UserPermissions = Record<string, unknown> | Array<Record<string, unknown>>

type SimpleAction = {
  type: string
  payload?: unknown
}

type Dispatch = (action: SimpleAction | unknown) => unknown


export const addNewContentReader = ({ id, username }: { id: string; username: string }) => {
  return {
    type: actionTypes.PERMISSIONS.NEW_CONTENT.READERS.ADD,
    payload: { id, username }
  }
}

export const removeNewContentReader = ({ id }: { id: string }) => {
  return {
    type: actionTypes.PERMISSIONS.NEW_CONTENT.READERS.REMOVE,
    payload: { id }
  }
}

export const addNewContentWriter = ({ id, username }: { id: string; username: string }) => {
  return {
    type: actionTypes.PERMISSIONS.NEW_CONTENT.WRITERS.ADD,
    payload: { id, username }
  }
}

export const removeNewContentWriter = ({ id }: { id: string }) => {
  return {
    type: actionTypes.PERMISSIONS.NEW_CONTENT.WRITERS.REMOVE,
    payload: { id }
  }
}

export const clearNewContentPermissions = () => {
  return {
    type: actionTypes.PERMISSIONS.NEW_CONTENT.CLEAR
  }
}

export const setNewContentPermissions = ({ readers = {}, writers = {} }: { readers?: UserPermissions; writers?: UserPermissions }) => {
  return {
    type: actionTypes.PERMISSIONS.NEW_CONTENT.SET,
    payload: { readers, writers }
  }
}

export const expandNewContentPermissions = () => {
  return (dispatch: Dispatch) => {
    dispatch(clearModes())
    return dispatch({ type: actionTypes.PERMISSIONS.NEW_CONTENT.EXPAND })
  }
}

export const collapseNewContentPermissions = () => {
  return {
    type: actionTypes.PERMISSIONS.NEW_CONTENT.COLLAPSE
  }
}

export const togglePermissions = () => {
  return {
    type: actionTypes.PERMISSIONS.TOGGLE
  }
}
